/* Nera³ homepage — pinned-stage pane animation, horizontal frames, carousel rails.
   Ported from the design runtime (Nera3-Home-FINAL.dc.html Component/DCLogic block)
   to plain JS. No design-runtime dependencies.
   - tick(): drives [data-pane] 1–4 inside [data-stage-wrap] (vertical pane walk)
   - tickH(): drives [data-hframe]/[data-htext] 0–3 (horizontal frame slide-in)
   - rails: [data-rail-prev]/[data-rail-next] buttons nudge the [data-rail]
     scroller inside their [data-rail-scope] (atelier products, recommended
     videos, #nera3 social). */
(function () {
  'use strict';
  if (window.__neraHomeStage) return;
  window.__neraHomeStage = true;

  function tick() {
    var w = document.querySelector('[data-stage-wrap]');
    if (!w) return;
    var vh = innerHeight, r = w.getBoundingClientRect();
    var P = Math.max(0, Math.min(1, -r.top / (r.height - vh)));
    var p = Math.min(1, (P / 0.46) * 0.8875); // panes live in the first 46% of the pin
    var N = 4, span = 1 / (N + 0.35);
    for (var i = 1; i <= N; i++) {
      var el = document.querySelector('[data-pane="' + i + '"]');
      if (!el) continue;
      var t = (p - (i - 1) * (span * 0.82)) / span;
      if (i === N) t = Math.min(t, 0.5);
      var vis = t > -0.1 && t < 1.1;
      el.style.visibility = vis ? 'visible' : 'hidden';
      if (!vis) continue;
      var c = Math.max(0, Math.min(1, t));
      // long deceleration into a short hold (0.46–0.54), mirrored out
      var V = 1 / 0.72, B = 0.12, C = 0.30;
      var leg = function (x) { return x <= C ? V * x : V * C + V * (x - C) - V * (x - C) * (x - C) / (2 * B); };
      var d;
      if (c < 0.42) d = leg(c);
      else if (c > 0.58) d = 1 - leg(1 - c);
      else d = 0.5;
      var y = (0.5 - d) * (vh * 1.16);
      var o = 1;
      if (c < 0.12) o = c / 0.12;
      if (c > 0.88 && i !== N) o = (1 - c) / 0.12;
      // pane 4 settles only briefly at center, then RELEASES early (from
      // P=0.40, well before the overture) so the scroll never feels stuck —
      // Dean: a long hold makes people double-swipe and overshoot
      if (i === N) {
        var ex = Math.max(0, Math.min(1, (P - 0.40) / 0.116));
        ex = 1 - Math.pow(1 - ex, 3);
        y -= ex * vh * 0.55;
        o = Math.min(o, 1 - ex);
      }
      el.style.transform = 'translateY(calc(-50% + ' + y.toFixed(1) + 'px))';
      el.style.opacity = String(Math.max(0, Math.min(1, o)));
    }
    tickH();
  }

  /* Overture: the first POV slice of the horizontal band stacks the phrase
     one word at a time in big thin caps (entrances overlap ~50% so the build
     is fluid) while a veil darkens the stage; then the LOGO flies in from the
     right riding a black wipe that swipes the words out, and parks on the
     exact spot the first slide's own logo occupies. The slide starts entering
     at PFRAME (before the logo lands) so it is dragged in behind the logo:
     logo stops first, slide catches up and stops, then kicker + paragraph
     arrive and the flying logo cross-fades into the slide's logo. Everything
     is a pure function of scroll position, so scrubbing replays in reverse. */
  var POV = 0.26;

  function tickH() {
    var w = document.querySelector('[data-stage-wrap]');
    if (!w) return;
    var vh = innerHeight, r = w.getBoundingClientRect();
    var P = Math.max(0, Math.min(1, -r.top / (r.height - vh)));
    var p = Math.max(0, (P - 0.46) / 0.54);
    /* desktop: the slide starts when the logo is about halfway across
       (quintic ease hits 50% travel around po 0.57 ≈ p 0.148);
       MOBILE: the slide waits until the logo has fully reached its position
       (logo lands at po 0.90 ≈ p 0.234) so the word lockup stays up longer */
    var pframe = innerWidth <= 760 ? 0.235 : 0.15;
    var pf = Math.max(0, (p - pframe) / (1 - pframe));
    var N = 3, seg = 1 / (N + 1);
    var o0 = 0, t0v = 0, f0tx = 0, f1x = innerWidth;
    for (var i = 0; i <= N; i++) {
      var f = document.querySelector('[data-hframe="' + i + '"]');
      if (!f) continue;
      var t = Math.max(0, Math.min(1, (pf - i * seg) / (seg * 0.72)));
      // cruise then brake to a stop at the left edge
      var e = t < 0.6 ? t * 0.9 / 0.6 : 0.9 + 0.1 * (1 - Math.pow(1 - (t - 0.6) / 0.4, 3));
      f.style.transform = 'translateX(' + ((1 - e) * 100).toFixed(2) + '%)';
      if (i === 0) { f0tx = (1 - e) * innerWidth; t0v = t; }
      if (i === 1) f1x = (1 - e) * innerWidth;
      var txt = document.querySelector('[data-htext="' + i + '"]');
      if (txt) {
        var o = Math.max(0, Math.min(1, (t - 0.82) / 0.18));
        txt.style.opacity = String(o);
        if (i === 0) {
          // frame 0: kicker drops in from the top, paragraph rises from the
          // bottom; the logo itself is handed off from the overture flight
          o0 = o;
          txt.style.transform = 'none';
          var k = txt.querySelector('[data-h0-kicker]');
          if (k) k.style.transform = 'translateY(' + ((o - 1) * 36).toFixed(1) + 'px)';
          var pp = txt.querySelector('[data-h0-para]');
          if (pp) pp.style.transform = 'translateY(' + ((1 - o) * 36).toFixed(1) + 'px)';
        } else {
          txt.style.transform = 'translateY(' + ((1 - o) * 28) + 'px)';
        }
      }
    }
    overture(Math.max(0, Math.min(1, p / POV)), o0, t0v, f0tx, f1x);
  }

  function overture(po, o0, t0v, f0tx, f1x) {
    var root = document.querySelector('[data-overture]');
    if (!root) return;
    var vh = innerHeight, vw = innerWidth;
    function win(a, b) { return Math.max(0, Math.min(1, (po - a) / (b - a))); }
    function ease(x) { return 1 - Math.pow(1 - x, 3); }
    // the word lockup rides ABOVE the incoming slide and fades out on the
    // slide's progress. Desktop: starts fading when the slide is about
    // halfway (t0≈0.33), gone before the tagline/paragraph arrive (0.82).
    // MOBILE: quicker — mostly gone by the time the image reaches the words.
    var wa = vw <= 760 ? 0.10 : 0.33, wb = vw <= 760 ? 0.45 : 0.82;
    var wOut = 1 - Math.max(0, Math.min(1, (t0v - wa) / (wb - wa)));
    wOut = wOut * wOut * (3 - 2 * wOut);
    // entrances run ~a third slower than the first cut, still overlapping
    // (each word starts when the previous is about halfway home)
    var e1 = ease(win(0.02, 0.34));
    var w1 = document.querySelector('[data-ov-word="1"]');
    if (w1) { w1.style.opacity = (Math.min(1, e1 * 1.5) * wOut).toFixed(3); w1.style.transform = 'translateY(' + ((1 - e1) * vh * 0.45).toFixed(1) + 'px)'; }
    var e2 = ease(win(0.18, 0.50));
    var w2 = document.querySelector('[data-ov-word="2"]');
    if (w2) { w2.style.opacity = (Math.min(1, e2 * 1.5) * wOut).toFixed(3); w2.style.transform = 'translateX(' + ((1 - e2) * vw * 0.6).toFixed(1) + 'px)'; }
    var e3 = ease(win(0.34, 0.66));
    var w3 = document.querySelector('[data-ov-word="3"]');
    if (w3) { w3.style.opacity = (Math.min(1, e3 * 1.5) * wOut).toFixed(3); w3.style.transform = 'translateY(' + ((1 - e3) * vh * 0.4).toFixed(1) + 'px)'; }
    // the veil takes the stage to COMPLETE black by the time the logo is
    // halfway across (po≈0.57) — so the incoming slide's edge never shows
    var ev = win(0, 0.55); ev = ev * ev * (3 - 2 * ev);
    var veil = root.querySelector('[data-ov-veil]');
    if (veil) { veil.style.opacity = ev.toFixed(3); }
    // the logo flies to the exact spot the slide's logo occupies (measured
    // live so the handoff is seamless at any viewport), then cross-fades.
    // Quintic ease-out: fast entry, long deceleration ramp into position so
    // the slide visibly catches up behind it.
    var lg = document.querySelector('[data-ov-logo]');
    var target = document.querySelector('[data-h0-logo]');
    if (lg && target) {
      // the slide's logo is measured while its frame may still be traveling —
      // subtract the frame's current offset to get the LANDED position
      var tr = target.getBoundingClientRect();
      var landedLeft = tr.left - (f0tx || 0);
      // pin the script-word lockup so its last line sits right above where
      // the logo lands, on every screen size
      var wc = document.querySelector('[data-ov-words]');
      if (wc) { wc.style.top = Math.max(16, tr.top - 30 - wc.offsetHeight) + 'px'; }
      var elx = win(0.52, 0.90);
      var el = 1 - Math.pow(1 - elx, 5);
      lg.style.width = tr.width.toFixed(1) + 'px';
      lg.style.left = landedLeft.toFixed(1) + 'px';
      lg.style.top = tr.top.toFixed(1) + 'px';
      lg.style.transform = 'translateX(' + ((1 - el) * (vw - landedLeft + tr.width)).toFixed(1) + 'px)';
      // the flown-in logo IS the slide's logo — it stays at full opacity and
      // gets physically COVERED by slide 2 (it sits between the two slides in
      // the stack), the same way the rest of slide 1's content is covered
      lg.style.opacity = Math.min(1, el * 1.4).toFixed(3);
    }
  }

  function nudge(el, dir) {
    if (!el) return;
    var first = el.firstElementChild;
    var step = first ? (first.getBoundingClientRect().width + 16) : el.clientWidth * 0.7;
    el.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  function init() {
    // Carousel prev/next buttons
    var btns = document.querySelectorAll('[data-rail-prev],[data-rail-next]');
    Array.prototype.forEach.call(btns, function (btn) {
      btn.addEventListener('click', function () {
        var scope = btn.closest('[data-rail-scope]');
        var rail = scope && scope.querySelector('[data-rail]');
        nudge(rail, btn.hasAttribute('data-rail-next') ? 1 : -1);
      });
    });

    // Pinned stage
    if (!document.querySelector('[data-stage-wrap]')) return;
    var rq = false;
    var onScroll = function () {
      if (!rq) {
        rq = true;
        requestAnimationFrame(function () { rq = false; tick(); });
      }
    };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll);
    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
